import { render } from "./createInstance.vue?vue&type=template&id=4958340c"
import script from "./createInstance.vue?vue&type=script&lang=js"
export * from "./createInstance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__